export interface Coords {
  lat: number;
  lng: number;
}

// Mejor esfuerzo: nunca rechaza ni bloquea. Si el navegador no soporta
// geolocalización, el usuario la niega, o no hay señal a tiempo, resuelve null.
export function getCoordsBestEffort(): Promise<Coords | null> {
  return new Promise((resolve) => {
    if (!('geolocation' in navigator)) {
      resolve(null);
      return;
    }
    navigator.geolocation.getCurrentPosition(
      (pos) => resolve({ lat: pos.coords.latitude, lng: pos.coords.longitude }),
      () => resolve(null),
      { timeout: 5000, enableHighAccuracy: false }
    );
  });
}
